export default "__VITE_ASSET__CL3UFu7E__"